import React, { useState, useEffect } from 'react'

import { Avatar, Theme, UiArrowExpandIcon } from '@octane/spark'
import { DropdownContent } from 'assets/styles/dropdown'
import AccountDropdownMenu from 'components/Navbar/AccountDropdownMenu/AccountDropdownMenu'
import useLoggedInUserDropdown from 'containers/Navbar/LoggedInUser/useLoggedInUserDropdown'
import { useBrandConfig as useBrandExperienceConfig } from 'contexts/BrandConfigContextProvider'
import { useTheme } from 'styled-components'

import {
    Greeting,
    DropdownWrapper,
    Wrapper,
    UserInfo,
} from './LoggedInUser.styled'

export default function LoggedInUserContainer(): JSX.Element {
    const { user, node, toggleDropdown, setToggleDropdown, handleLogout } =
        useLoggedInUserDropdown()

    const { navbarForceWhite } = useBrandExperienceConfig()
    const theme: Theme = useTheme() as Theme

    const [isNavbarWhite, setIsNavbarWhite] =
        useState<boolean>(navbarForceWhite)

    useEffect(() => {
        setIsNavbarWhite(navbarForceWhite)
    }, [navbarForceWhite])

    if (!user) {
        return <Wrapper />
    }

    return (
        <Wrapper
            data-testid="wrapper"
            ref={node}
            onClick={() => setToggleDropdown(!toggleDropdown)}
            isNavbarWhite={isNavbarWhite}
        >
            {user.firstName && user.lastName && (
                <Avatar
                    name={`${user.firstName} ${user.lastName}`}
                    size="large"
                    color="auto"
                />
            )}
            <UserInfo isNavbarWhite={isNavbarWhite}>
                <Greeting>Hi {user?.firstName}</Greeting>
                <DropdownWrapper data-testid="dropdown-toggle-your-account">
                    <span>Your Account</span>
                    <UiArrowExpandIcon
                        width={16}
                        height={16}
                        color={
                            isNavbarWhite
                                ? theme.colors.monochrome.ravenSub
                                : theme.colors.monochrome.white
                        }
                    />
                </DropdownWrapper>
                {toggleDropdown && (
                    <DropdownContent data-testid="dropdown-content">
                        <AccountDropdownMenu
                            user={user}
                            onLogout={handleLogout}
                        />
                    </DropdownContent>
                )}
            </UserInfo>
        </Wrapper>
    )
}
